// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"style_wrap_f0a5642f5c591eb7772ad5adea9fffc0"};